// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jBxTDOAZoaMGdvz71x3I{color:var(--content-primary-primary);border-top:1px solid var(--gray-20);padding:4px;font-size:13px;font-weight:400;line-height:16px}.gA8He3hUKewPIvY7kvLc{cursor:pointer;border-radius:4px;padding:8px 12px;display:flex}.gA8He3hUKewPIvY7kvLc:hover{background:var(--background-neutral-subtle)}.ZZOhlDdcUWgOn3aOTwwI{margin-left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `jBxTDOAZoaMGdvz71x3I`,
	"dropdownAction": `gA8He3hUKewPIvY7kvLc`,
	"dropdownActionText": `ZZOhlDdcUWgOn3aOTwwI`
};
export default ___CSS_LOADER_EXPORT___;
